import { logger } from "../utils/logger";
import { axios_adapter } from "./axios_adapter";
import network_contants from "./network_contants";

export async function attachIdentityIdToPolicyViaAPI(identityId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.ATTACH_POLICY_ENDPOINT(identityId), { baseURL: network_contants.AWS_IOT_BASE_URL });
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to attachIdentityIdToPolicy ${identityId} - ${error.message}`);
        return null;
    }
}

export async function tambolaBuyTicket(gameId) {
    try {
        const response = await axios_adapter.put(network_contants.ENDPOINTS.TAMBOLA_BUY_TICKET(gameId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaBuyTicket - ${error.message}`);
        return null;
    }
}

export async function tambolaGameList() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.TAMBOLA_GAME_LIST);
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to findActiveTambolaGame - ${error.message}`);
        return null;
    }
}

export async function tambolaJoinGame(gameId) {
    try {
        const response = await axios_adapter.put(network_contants.ENDPOINTS.TAMBOLA_JOIN_GAME(gameId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaJoinGame - ${error.message}`);
        return null;
    }
}

export async function getTambolaLeaderboard(gameId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.TAMBOLA_LEADERBOARD(gameId));
        logger.log("response : ", response);
        return response;
    }
    catch (error) {
        logger.log(`Failed to getTambolaLeaderboard - ${error.message}`);
        return null;
    }
}

export async function getTriviaCardV2(entityId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.TAMBOLA_ENTITY_TRIVIA_CARD(entityId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getTriviaCardV2 - ${error.message}`);
        return null;
    }
}

/**
 * 
 * @returns 
 * {
    "cognitoId": "0123bdda-3081-7098-be0d-2d5206481261",
    "userId": "23470ce7e18e61e220bb2d7a",
    "userName": "user_9643601011",
    "age": "27",
    "phoneNumber": "9643601011",
    "profilePic": "https://avatar.iran.liara.run/public/34",
    "rapCoinBalance": 1950,
    "referralCode": "7Amipoirwe50",
    "totalCoins": 1950,
    "totalGems": 0,
    "vipRoom": 0,
    "isPremium": false,
    "isProfileCreated": true
    }
 */
export async function getUserProfile() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.GET_PROFILE);
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getUserProfile - ${error.message}`);
        return null;
    }
}

export async function getUserNotifications() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.GET_USER_NOTIFICATIONS);
        return response;
    } catch (error) {
        logger.log(`Failed to getUserNotifications - ${error.message}`);
        return null;
    }
}

export async function markAllNotificationsRead() {
    try {
        const response = await axios_adapter.patch(
            network_contants.ENDPOINTS.MARK_ALL_NOTIFICATIONS_READ
        );
        return response;
    } catch (error) {
        logger.log(`Failed to markAllNotificationsRead - ${error.message}`);
        return null;
    }
}

/**
 * 
 * @param 
 *  userProfileData = {
    "userName": "Indian Hacker",
    "profilePicture": "https://avatar.iran.liara.run/public/34",
    "identityId": "ap-south-1:64038f50-1300-ce63-ad7a-62dcb58b84f5",
    "age": "27",
    "phoneNumber": 9989888795
}
 * @returns 
 */
export async function createUserProfile(userProfileData) {
    try {
        const response = await axios_adapter.post(network_contants.ENDPOINTS.CREATE_PROFILE, userProfileData);
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getUserProfile - ${error.message}`);
        return null;
    }
}

export async function tambolaUserRoom() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.TAMBOLA_USER_ROOM);
        logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaUserRoom - ${error.message}`);
        return null;
    }
}

export async function tambolaSelectRoom() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.TAMBOLA_SELECT_ROOM);
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaSelectRoom - ${error.message}`);
        return null;
    }
}

// {
//     "roomName":"02dec",
//     "roomType": "Family" | "Kitty" | "Corporate"
//     "roomImage": <file> // multipart, optional waiting lobby image/video
// }
const normalizeRoomType = (value = '') => {
    const key = String(value).toLowerCase();
    if (key.includes('kitty')) return 'Kitty';
    if (key.includes('corporate')) return 'Corporate';
    if (key.includes('family')) return 'Family';
    return null;
};

const isUploadFile = (value) =>
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    (typeof File !== 'undefined' && value instanceof File);

const buildCreateRoomFormData = (roomData, roomType) => {
    const formData = new FormData();
    formData.append('roomName', roomData?.roomName || '');
    formData.append('roomType', roomType);

    const mediaFile = roomData?.waitingMedia || roomData?.roomImage;
    if (isUploadFile(mediaFile)) {
        const fileName =
            mediaFile.name ||
            (String(mediaFile.type || '').startsWith('video/') ? 'waiting-media.mp4' : 'waiting-media.png');
        formData.append('roomImage', mediaFile, fileName);
    }

    return formData;
};

export async function tambolaCreateRoom(roomData) {
    try {
        const roomType = normalizeRoomType(roomData?.roomType);
        if (!roomType) {
            logger.log(`Failed to tambolaCreateRoom - invalid roomType: ${roomData?.roomType}`);
            return null;
        }

        const response = await axios_adapter.post(
            network_contants.ENDPOINTS.TAMBOLA_CREATE_ROOM,
            buildCreateRoomFormData(roomData, roomType)
        );
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaCreateRoom - ${error.message}`);
        return null;
    }
}

export async function tambolaJoinRoom(code) {
    try {
        const payload = {
            "code": code
        };
        const response = await axios_adapter.post(network_contants.ENDPOINTS.TAMBOLA_JOIN_ROOM, payload);
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaJoinRoom - ${error.message}`);
        return null;
    }
}

export async function startTambolaRoomGame(roomId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.TAMBOLA_GAME_ROOM(roomId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to tambolaGameRoom - ${error.message}`);
        return null;
    }
}

export async function getRapFireGameList() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_GAME_LIST);
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getRapFireGameList - ${error.message}`);
        return null;
    }
}

export async function getRapFireGameDetail(gameId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_GAME_DETAIL(gameId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getRapFireGameDetail - ${error.message}`);
        return null;
    }
}

export async function getRapFireLeaderboard(gameId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_LEADERBOARD(gameId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getRapFireLeaderboard - ${error.message}`);
        return null;
    }
}

export async function getTournamentLeaderboard(tournamentId) {
    const url = network_contants.ENDPOINTS.TOURNAMENT_LEADERBOARD(tournamentId);
    const config = {
        skipAuth: true,
        headers: { 'x-analytics-key': 'nexintain' },
    };

    try {
        const response = await axios_adapter.get(url, config);
        return response;
    } catch (error) {
        logger.log(`Failed to getTournamentLeaderboard - ${error.message}`);
        return null;
    }
}

export async function getRapFireParticipantsList(contestId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_GAME_PARTICIPANTS_LIST(contestId));
        //logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to getRapFireParticipantsList - ${error.message}`);
        return null;
    }
}

export async function rapFireUserRoom() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_USER_ROOM);
        logger.log("response : ", response);
        return response;
    } catch (error) {
        logger.log(`Failed to rapFireUserRoom - ${error.message}`);
        return null;
    }
}

export async function rapFireSelectRoom() {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_SELECT_ROOM);
        return response;
    } catch (error) {
        logger.log(`Failed to rapFireSelectRoom - ${error.message}`);
        return null;
    }
}

export async function rapFireCreateRoom(roomData) {
    try {
        const roomType = normalizeRoomType(roomData?.roomType);
        if (!roomType) {
            logger.log(`Failed to rapFireCreateRoom - invalid roomType: ${roomData?.roomType}`);
            return null;
        }

        const response = await axios_adapter.post(
            network_contants.ENDPOINTS.RAPFIRE_CREATE_ROOM,
            buildCreateRoomFormData(roomData, roomType)
        );
        return response;
    } catch (error) {
        logger.log(`Failed to rapFireCreateRoom - ${error.message}`);
        return null;
    }
}

export async function rapFireJoinRoom(code) {
    try {
        const payload = { code };
        const response = await axios_adapter.post(network_contants.ENDPOINTS.RAPFIRE_JOIN_ROOM, payload);
        return response;
    } catch (error) {
        logger.log(`Failed to rapFireJoinRoom - ${error.message}`);
        return null;
    }
}

export async function startRapFireRoomGame(contestId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_GAME_ROOM(contestId));
        return response;
    } catch (error) {
        logger.log(`Failed to startRapFireRoomGame - ${error.message}`);
        return null;
    }
}

export async function rapFireStartGame(contestId) {
    try {
        const response = await axios_adapter.get(network_contants.ENDPOINTS.RAPFIRE_START_GAME(contestId));
        return response;
    } catch (error) {
        logger.log(`Failed to rapFireStartGame - ${error.message}`);
        return null;
    }
}
